import type { PropsWithChildren, ReactElement } from 'react';
import styles from './PackageGroup.module.scss';
import { PackageSection } from './PackageSection';

type Props = PropsWithChildren<{
  categoryLabel: string;
}>;

export function PackageGroup(props: Props): ReactElement {
  return (
    <>
      <h4 className={styles.category}>{props.categoryLabel}</h4>
      <PackageSection>{props.children}</PackageSection>
    </>
  );
}
